export const JOB_STATUS = {
  IDLE: "idle",
  STARTING: "starting",
  RUNNING: "running",
  COMPLETED: "completed",
  ERROR: "error",
};

export const ALL_JOB_STATUS = Object.values(JOB_STATUS);
